/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import React, {Component, createRef} from 'react';
import { Spinner, Tooltip, OverlayTrigger, Image } from 'react-bootstrap';
import { BatterySymbol } from './InstallationCheck';

import AssetService from "../../services/asset.service";
import DeviceService from "../../services/device.service";
import AlertService from "../../services/alerts.service";

import ProvisioningService from "../../services/provisioning.service";

import SensorMapModal from "./SensorMapModal";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import '../../custom.css';
import HomeService from "../../services/home.service";

import { PageView, Event, Timing, ModalView } from "../GoogleAnalytics";
import {
    jsAsset,
    jsDevice,
    jsHouse,
    jsdeviceModels,
    jsdeviceClass,
    jsdevicetags,
    GraphTypes, AxisTypes, Equipment, roles
} from "../../componentObjects";
import moment from 'moment';

import RefreshIcon from '@mui/icons-material/Refresh';

import TechnicianView from "../Technician/TechnicianInfo";
import AssetHierarchyView from "../Assets/Hierarchy/AssetHierarchyView";
import DevTemp from './DevTemp';

import threadService from "../../services/thread.service";
import installService from "../../services/install.service";
import DeviceRequestsService from "../../services/devicerequests.service";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import DatePicker from 'react-datepicker';
import { addHours } from 'date-fns';
import ContextMenu from "../ContextMenu/contextMenu";

import Pagination from '@mui/material/Pagination';
import Loader from "../Loader/Loader";
import GraphComponent from "../Graph/GraphComponent";
import DiagnosticsModal from "./DiagnosticsModal";
import DiagnosticsTestModal from "./DiagnosticTestModal";
import IconButton from "@mui/material/IconButton";
import HistoricalInstallCheckModal from "./HistoricalInstallCheck/HistoricalInstallCheckModal";
import {forEach} from "react-bootstrap/ElementChildren";


//const timeout = 300000; //300,000 milliseconds = 5 minutes
const DEVICE_STATUS_THREAD_NAME = "Device Status_LPX";
const STATUS_PROP_NAME = "Status";
const NEWCLASS ="New";
const  REPROVISIONCLASS = "Reprovision";


const FLYCATCHER_PROP_DICT = {
    "AirConditioner": [
        "Current",
        "SubgRSSI",
        "WifiRSSI",
        "batteryVoltage",
        "deviceTemperature",
        "CompressorCurrent",
        "CoolingFanCurrent"
    ],
    "Furnace": [
        "Current",
        "SubgRSSI",
        "WifiRSSI",
        "batteryVoltage",
        "deviceTemperature",
        "BlowerCurrent",
        "InducerCurrent",
        "virtualCurrent"
    ]
}

const DIAGNOSTIC_PROPS = {
    DROPOUT_CUMULATIVE: "dropout_cumulative",
    DROPOUT_SECONDS_CUMULATIVE: "dropout_seconds_cumulative",
    RUNS_LAST24H: "Runs_Last24h",
    RUNS_CUMULATIVE: "Runs_Cumulative"
};


const PageSize = 20;
const LifePulseT10 = "LifePulseT10";
const ThreeCTDeviceTag = "3CT";

function collect(props) {
    return props;
}

function getPrettyName(name) {
    if (name !== null && name !== undefined) {

        var split = name.split("__");
        return split[0];
    }
    else {
        return "";
    }
}

class Devices extends Component {
    static displayName = Devices.name;

    _isMounted = false;

    constructor(props) {
        super(props);

        this.onAssetClick = this.onAssetClick.bind(this);
        this.onContextClick = this.onContextClick.bind(this);

        this.openDiagnosticsTestModal = this.openDiagnosticsTestModal.bind(this);
        this.showDiagnosticsTestModal = this.showDiagnosticsTestModal.bind(this);
        this.openDiagnosticsModal = this.openDiagnosticsModal.bind(this);
        this.showDiagnosticsModal = this.showDiagnosticsModal.bind(this);

        this.openRepairSensorMapModal = this.openRepairSensorMapModal.bind(this);
        this.showRepairSensorMapModal = this.showRepairSensorMapModal.bind(this);
        this.mapSensor = this.mapSensor.bind(this);
        this.updateSensorMap = this.updateSensorMap.bind(this);
        this.onHVACSystemSelect = this.onHVACSystemSelect.bind(this);
        this.onNoAssetsReturned = this.onNoAssetsReturned.bind(this);
        this.setTechnicianInfo = this.setTechnicianInfo.bind(this);

        this.openTTConfirmModal = this.openTTConfirmModal.bind(this);
        this.showTTConfirmModal = this.showTTConfirmModal.bind(this);
        this.onTTConfirm = this.onTTConfirm.bind(this);
        this.refreshStatus = this.refreshStatus.bind(this);
        this.refreshAllStatus = this.refreshAllStatus.bind(this);
        this.refreshorgetDevicelogs = this.refreshorgetDevicelogs.bind(this);

        this.setDevices = this.setDevices.bind(this);
        this.handleCheckbox = this.handleCheckbox.bind(this);
        this.getHighchartsTimelineData = this.getHighchartsTimelineData.bind(this);
        this.populateAssetData = this.populateAssetData.bind(this);
        this.onViewRuns = this.onViewRuns.bind(this);
        this.getFirmwareData = this.getFirmwareData.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
        this.getdeviceodel = this.getdeviceodel.bind(this);
        
        this.onDeleteHomeSelect = this.onDeleteHomeSelect.bind(this);
        this.deleteHome = this.deleteHome.bind(this);
        this.openDeleteHomeModal = this.openDeleteHomeModal.bind(this);
        this.onExtendDataLeft = this.onExtendDataLeft.bind(this);
        
        this.handleViewInstallCheckReportsClicked = this.handleViewInstallCheckReportsClicked.bind(this);
        this.validateThreeCTDevice = this.validateThreeCTDevice.bind(this);

        this.state = {
            deviceList: [],
            assetList: [],

            currentHVACSystem: jsHouse,
            currentAsset: jsAsset,
            currentDevice: jsDevice,
            currentInstall: {},
            currentInstallTechStr: "",

            loading: false,
            assetInfoLoading: false,
            configLoading: false,
            viewLoading: false,
            isSelected: -1,
            isFlyCatcher: false,
            showRepairSensorMap: false,
            showDiagnostics: false,
            showDiagnosticsTest: false,
            showHistoricalInstallChecks: false,
            diagnosticsLoading: false,
            gatewayRebootCodes: [],
            showTTConfirm: false,
            modalMessage: "",
            modalTitle: "",
            statusMessage: null,
            showStatusMessage: null,
            tooltipSensorOpen: false,
            setTooltipSensorOpen: true,
            tooltipWifiOpen: false,
            deviceConfiguration: "",
            devTTUrl: "",
            updateStatusProgress: "",
            isUpdated: false,
            isTimeout: false,
            statusLoading: false,
            statusLoadingList: [],
            isCustomerSupport: localStorage.getItem('isCustomerSupport') === 'true' || false,

            sensorsLoading: false,
            currentSensor: null,
            sensorList: [],
            unmappedProperties: [],
            mappedSensors: [],
            mapDict: {}, //{propertyIndex: (isMapped ? sensorndex : -1)}
            isSystemChanged: false,
            logListGateway: [],
            logListSH1: [],
            logListSH2: [],
            selectedDeviceId: "",
            deviceGraph: [],
            leftHours: 0,
            extendedLoading: false,
            visibility: {
                wifirssi: true,
                subgrssi: false,
                batteryVoltage: false,
                current: false,
                devicetemperature: false,
                gatewayResets: false,
                gatewayRebootOverflow: false
            },
            dpStartDateTime: null,
            dpEndDateTime: null,
            startDateTimeStr: "",
            endDateTimeStr: "",
            firmware: {
                gatewayversion: 0,
                serverLoggedin: 0,
                firmwareversion: 0,
                shtype: "",
                class: "",
                gatewayLoggedin: 0,
                reprovosionresult : ""
            },
            pageCountGateway: 1,
            currentPageGateway: 1,
            pageCountSH1: 1,
            currentPageSH1: 1,
            pageCountSH2: 1,
            currentPageSH2: 1,
            paginglogListGateway: [],
            paginglogListSH1: [],
            paginglogListSH2: [],
            showDeviceLogs: false,
            selectedRowIdForContextMenu: null,
            devicetags :[],
            deviceAppliedClasses :[],
            showDeleteHomeConfirmation :false,
            deleteHomeAssetId : "",
            isDeleted : false ,
            isThreeCTDevice : false,
        };
        this.contextMenuRef = createRef();
    }

    componentDidMount() {
        this._isMounted = true;
        PageView();
        this.populateAssetData();
        this.setState({ loading: true });
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.currentCustomerId !== this.props.currentCustomerId) {
            this.populateAssetData();
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    onDeleteHomeSelect(e) {
        let homeAssetId = "";
        if(e?.orgId)
        {
            homeAssetId = e?.orgId;
        }

        this.setState({
            showDeleteHomeConfirmation: !this.state.showDeleteHomeConfirmation,
            modalMessage: "Are you sure you wish to delete this Home?",
            modalTitle: "Delete Home" ,
            deleteHomeAssetId : homeAssetId
        }, () => {
            if (this.state.showDeleteHomeConfirmation) {

                ModalView("deleteHomeConfirm");
            }
        });
        window.scrollTo(0, 0);
    }

    deleteHome() {
        this.setState({ loading: true });
        HomeService.delete(this.state.deleteHomeAssetId, this.props.currentCustomerId, this.props.currentPartnerId)
            .then(response => {
                let message = "";

                if (response.status === 200 && response.data !== undefined && response.data !== null && response.data !== false) {
                    message = "Successfully deleted home!";
                    Event("Delete Home Clicked", "User clicked delete home button", "Delete Customer Home Clicked");

                    if (this._isMounted)
                        this.setState({ statusMessage: message, showDeleteConfirmation: false, loading: false, deleteHomeAssetId :"" ,showDeleteHomeConfirmation : false, isDeleted : true,  confirmationhvacUpdatedText : message});

                }
                else {
                    message = "Failed to delete home!";

                    if (this._isMounted)
                        this.setState({ statusMessage: message, showDeleteConfirmation: false, loading: false ,deleteHomeAssetId :"", showDeleteHomeConfirmation : false ,isDeleted : true , confirmationhvacUpdatedText : message});
                }


            })
            .catch(e => {
                console.log(e);
                this.setState({ loading: true });
            });
    }

   async validateThreeCTDevice()
    {
        let isThreeCTDeviceFound = false;
        if (!isThreeCTDeviceFound) {
            for (let i = 0; i < this.state.assetList.length && !isThreeCTDeviceFound; i++) {
                if (!this.state.assetList[i]?.assetId) continue;
                await AssetService.getappliedtags(this.state.assetList[i].assetId).then(response => {
                    if (response.status === 200 && response.data && response.data.some(t => t.name === ThreeCTDeviceTag)) {
                        this.setState({ isThreeCTDevice: true });
                        isThreeCTDeviceFound = true;
                    }
                    else
                    {
                        this.setState({ isThreeCTDevice: false });
                    }
                }).catch(e => {
                    console.log(e);
                });
            }
        }
    }
    
    openDeleteHomeModal() {
        this.setState({ modalMessage: "Are you sure you wish to delete this Home?", modalTitle: "Delete Home" }, () => {
            this.showDeleteHomeModal();
        });
    }
    onNoAssetsReturned() {
        this.setState({ loading: false, assetList: [], deviceList: [] });
    }

    async setDevices() {
        if (this.state.currentHVACSystem.children.length) {
            var startTime = performance.now();
            let devices = this.state.currentHVACSystem.children.map(d => d.id);
            await AssetService.getassetsproperties(devices).then(hvacsResponse => {
                if (this._isMounted) {
                    if (hvacsResponse.data !== null && hvacsResponse.data !== undefined) {
                        var newAssetList = hvacsResponse.data;
                        if (newAssetList !== null && newAssetList !== undefined && newAssetList.length && this.props.hasServiceTier && this.props.serviceTier < 3)
                            newAssetList = newAssetList.filter(n => n.type.trim() === "Thermostat");
                        for (let i = 0; i < newAssetList.length; i++) {
                            for (let j = 0; j < this.state.currentHVACSystem.children.length; j++) {
                                if (newAssetList[i].assetId === this.state.currentHVACSystem.children[j].id) {
                                    newAssetList[i].mac = this.state.currentHVACSystem.children[j].name;
                                    newAssetList[i].name = this.state.currentHVACSystem.children[j].name;
                                }
                            }
                        }
                        this.setState({ assetList: newAssetList, currentAsset: jsAsset, currentDevice: jsDevice, isSelected: -1, deviceList: [] }, async () => {
                            await AssetService.getassetdevices(this.state.currentHVACSystem.id, this.state.assetList)
                                .then(response => {
                                    if (this._isMounted) {
                                        let id = response.data.length > 0 ? response.data[0].mac : "";
                                       
                                        this.setState({ loading: false, deviceList: response.data, isSystemChanged: false, selectedDeviceId: id },
                                            () =>{
                                           this.validateThreeCTDevice();
                                            });
                                    }
                                });
                            var elapsedTime = performance.now() - startTime;
                            Timing("Assets Loading", "loading", elapsedTime, "Customer Assets Loading");
                        });
                    } else {
                        this.setState({ loading: false }, () => {
                            var elapsedTime = performance.now() - startTime;
                            Timing("Assets Loading", "loading", elapsedTime, "Customer Assets Loading");
                        });
                    }
                }
            });
        } else {
            this.setState({ loading: false, assetList: [], currentAsset: jsAsset, deviceList: [] }, async () => {
                var elapsedTime = performance.now() - startTime;
                Timing("Assets Loading", "loading", elapsedTime, "Customer Assets Loading");
            });
        }
    }
    getMacId(assets) {
        if (assets !== null && assets !== undefined && assets.length) {
            if (assets.length > 1) {
                if (assets.filter(a => a.type.trim() !== "Thermostat").length)
                    return assets.filter(a => a.type.trim() !== "Thermostat")[0].mac;
            }
            else
                return assets[0].mac;
        }
    }

    cleanMapping(path) {
        if (path) {
            var namesArray = path.split(" / ");

            for (var i = 0; i < namesArray.length; i++) {
                namesArray[i] = getPrettyName(namesArray[i]);
            }

            var resultString = namesArray.join(" / ");

            return resultString;
        }
        else {
            return "";
        }
    }

    setTechnicianInfo(e) {
        if (e !== undefined) {
            this.setState({ isFlyCatcher: e.gatewayTypeId === 2 ? true : false });
        }
    }

    onHVACSystemSelect(e) {
        if (e !== undefined) {
            Event("Customer HVAC System Selected", "User selected one of the customers HVAC systems in dropdown", "Customer HVAC System Selected");
            this.setState({
                currentHVACSystem: e,
                currentDevice: jsDevice,
                deviceConfiguration: "",
                isSelected: -1,
                isSystemChanged: e.id !== this.state.currentHVACSystem.id
            }, async () => {
                await this.setDevices(this.state.currentHVACSystem);
            });
        } 
    }

    async onHomeSelect(e) {
        let x = e.target.value;

        this.setState({ newHouseLoading: true, isSelected: -1 }, () => {
            this.getDevices(x);
        });
    }

    async onViewRuns() {
        this.setState({ configLoading: true, viewLoading: true, leftHours: 0 }, async () => {
            let devices = this.state.assetList;
            await AlertService.getdevicegraphdata(this.state.startDateTimeStrPlus, this.state.endDateTimeStrPlus, devices)
                .then(response => {
                    if (response.data != null) {
                        this.setState({
                            deviceGraph: response.data,
                            loading: false,
                            configLoading: false,
                            viewLoading: false
                        });
                    }

                }).catch(e => {
                    this.setState({
                        loading: false
                    });
                });
        })
    }

    async getFirmwareData() {
        let endDate = moment().format();
        let startDate = moment(endDate).add(-24, 'hours').format();
        let selectedDevice = this.state.selectedDeviceId?.split("-");
        let configData = (this.state.deviceConfiguration !=="")? JSON.parse(this.state.deviceConfiguration) :"";
        let gatewayversion = 0;
        let serverLoggedin = 0;
        let gatewayLoggedin = 0;
        let firmwareversion = 0;
        let assetLiast = this.state.assetList;
        let assetClasses = "";
        let reprovisionStatus = "";
        assetLiast = assetLiast?.find(x => x.name == this.state.selectedDeviceId)?.properties;
        let assettype = assetLiast?.find(x => x.description == "shType")?.value;
        gatewayversion = this.state.logListGateway?.length > 0 ? this.state.logListGateway[0]?.firmwareRevision : 0;
        gatewayLoggedin = this.state.logListGateway?.length > 0 ? this.state.logListGateway?.filter(x => x.date >= startDate)?.length : 0;
        serverLoggedin = this.state.logListSH1?.length > 0 ? this.state.logListGateway?.filter(x => x.date >= startDate)?.length : 0;
        firmwareversion = this.state.logListSH1?.length > 0 ? this.state.logListSH1[0]?.firmwareRevision : 0;

        if (configData != undefined && configData?.mac != undefined && configData?.mac != "") {
            let assetId = (configData?.mac == selectedDevice[0]) ? configData?.lpxs?.find(x => x.id == selectedDevice[1])?.mac : null;
            let assets = (configData?.mac == selectedDevice[0]) ? configData?.lpxs?.find(x => x.id == selectedDevice[1])?.assets : null;
            let gatewayversion = configData?.version;
            let noTimesassetLogin = 0;
            if (assets != null && assets != undefined && assets.length > 0) {

                assetClasses = assets[0]?.ttClasses
                if (assetClasses?.includes(REPROVISIONCLASS))
                {
                    reprovisionStatus= "Fail" ;
                }
                else  if (!assetClasses?.includes(NEWCLASS) && !assetClasses?.includes(REPROVISIONCLASS))
                {
                    reprovisionStatus= "Success";
                }
                else
                {
                    reprovisionStatus = "N/A";
                }
            }
        }

        this.setState({
            configLoading: false,
            firmware: {
                serverLoggedin: serverLoggedin,
                firmwareversion: firmwareversion,
                shtype: assettype,
                class: assetClasses,
                gatewayversion: gatewayversion,
                gatewayLoggedin: gatewayLoggedin,
                reprovosionresult : reprovisionStatus
            }
        });


    }
    async getDevices(id) {
        var startTime = performance.now();
        this.setState({
            currentHome: this.state.homeList[id], isSelected: -1
        }, async () => {

            const hvacFetch = this.state.currentHome.proLocationId
                ? AssetService.gethvacassetsbylocation(this.state.currentHome.proLocationId)
                : AssetService.gethvacassets(this.state.currentHome.houseAssetId);

            await hvacFetch.then(response => {
                if (this._isMounted)
                    this.setState({ hvacList: response.data, currentHVACSystem: response.data !== null && response.data !== undefined && response.data.length ? response.data[0] : jsHouse }, async () => {
                        // set a selected hvac system, then get the list of each asset for that system.. just like for home, 

                        if (this.state.currentHVACSystem !== undefined && this.state.currentHVACSystem !== null) {
                            // Pro / flattened customers have no TT org hierarchy under the HVAC system,
                            // so the org-hierarchy lookup (AssetService.get) returns an empty assetList.
                            // Use the parent-child search (getassetsbyparent) for those, which finds the
                            // device assets directly under the HVAC system's assetId. Fall back to the
                            // legacy org-hierarchy lookup for non-pro customers.
                            const assetFetch = this.state.currentHome.proLocationId
                                ? AssetService.getassetsbyparent(this.state.currentHVACSystem.assetId)
                                : AssetService.get(this.state.currentHVACSystem.assetId);

                            await assetFetch.then(response2 => {
                                if (this._isMounted)
                                    this.setState({ assetList: response2.data, currentAsset: response2.data !== null && response2.data !== undefined && response2.data.length ? response2.data[0] : jsAsset }, async () => {
                                        //await DeviceService.get(this.state.assetList)
                                        //    .then(response => {
                                        //        if (this._isMounted)
                                        //            this.setState({ deviceList: response.data }, () => {
                                        //                this.setState({ newHouseLoading: false }, () => {
                                        //                    var elapsedTime = performance.now() - startTime;
                                        //                    Timing("Devices Loading", "loading", elapsedTime, "Customer Devices Loading");
                                        //                });
                                        //            })
                                        //    });

                                        await AssetService.getassetdevices(this.state.currentHVACSystem.assetId, this.state.assetList)
                                            .then(response => {
                                                if (this._isMounted)
                                                    this.setState({ deviceList: response.data, loading: false }, async () => {
                                                        var macId = this.getMacId(this.state.assetList);
                                                        await installService.getinstallbymacid(macId).then(response3 => {
                                                            let install = response3;
                                                            if (install !== null && install !== undefined) {
                                                                let techStr = install.technicianName !== null && install.technicianName !== undefined ? install.technicianName + " (" + install.technicianEmail + ") " + moment(install.startDateTime).format("MM/DD/YYYY hh:mm a") : "";
                                                                let isFlyCatcher = install.gatewayTypeId === 2;
                                                                this.setState({
                                                                    currentInstall: install,
                                                                    currentInstallTechStr: techStr,
                                                                    isFlyCatcher: isFlyCatcher,
                                                                    newHouseLoading: false
                                                                }, () => {
                                                                    var elapsedTime = performance.now() - startTime;
                                                                    Timing("Devices Loading", "loading", elapsedTime, "Customer Devices Loading");
                                                                });
                                                            }
                                                        })
                                                    })
                                            });
                                    });
                            });
                        }
                        else {
                            this.setState({ newCustomerLoading: false });
                        }

                    });
            });
        });
    }

    async onAssetClick(index, id) {
        let x = index;
        let prettyPrint = "";
        var startTime = performance.now();
        Event("Device Clicked", "User clicked on device in table", "Customer Device Clicked");

        this.setState({ assetInfoLoading: true, configLoading: true, currentDevice: jsDevice, isSelected: index }, () => {
            this.setState({
                currentDevice: this.state.deviceList !== undefined && this.state.deviceList.length > x ? this.state.deviceList.find(x=> x.parentId === id) : jsDevice,
                currentAsset: this.state.assetList !== undefined && this.state.assetList.length > x ? this.state.assetList.find(x => x.assetId === parseInt(id)) : jsAsset,
                statusMessage: ""
            }, async () => {
                let DeviceId = this.state.currentDevice.mac;
                await ProvisioningService.getconfig(this.state.currentDevice.mac)
                    .then(response => {
                        prettyPrint = JSON.stringify(response.data, null, 2);
                        this.setState({ deviceConfiguration: prettyPrint, assetInfoLoading: false, loading: false, selectedDeviceId: DeviceId }, () => {
                            this.refreshorgetDevicelogs();
                            var elapsedTime = performance.now() - startTime;
                            Timing("Device Info Loading", "assetInfoLoading", elapsedTime, "Customer Device Info Loading");
                        });
                    })
                    .catch(e => {
                        console.log(e);
                        this.setState({ assetInfoLoading: false, configLoading: false, loading: false });
                    })
                if (this.state.currentAsset?.assetId) {
                    await AssetService.getappliedtags(this.state.currentAsset.assetId).then(response => {
                        if (response.status === 200 && response.data && response.data.some(t => t.name === LifePulseT10)) {
                            this.setState({ showDeviceLogs: false, devicetags: response.data });
                        }
                        else {
                            this.setState({ showDeviceLogs: true, devicetags: response.data });
                        }
                    }).catch(e => {
                        console.log(e);
                        this.setState({ showDeviceLogs: true, devicetags: [] });
                    });
                }

                await AssetService.getappliedclasses(this.state.currentAsset.assetId)
                    .then(response => {
                        this.setState({ deviceAppliedClasses: response.data });
                    })
                    .catch(e => {
                        console.log(e);
                    });

            });
        });
    }

    handleContextMenu= (e, id) => {
        e.preventDefault();
        this.setState({ selectedRowIdForContextMenu: id });
        if (this.contextMenuRef.current) {
            this.contextMenuRef.current.show({
                    event: e
                }
            );
        }
    }
    onContextClick = (option) => {
        const {selectedRowIdForContextMenu} = this.state;
        if (selectedRowIdForContextMenu !== null) {
            this.setState({ devTTUrl: "https://app.lifewhere.com/twins/detail/" + selectedRowIdForContextMenu })
            this.openTTConfirmModal();
        }
    }

    showTTConfirmModal() {
        this.setState({ showTTConfirm: !this.state.showTTConfirm });
    }

    openTTConfirmModal() {
        this.setState({ modalMessage: "You are about to leave the LifeWhere portal and be taken to the Device Properties page in TwinThread. Do you wish to continue?", modalTitle: "Leave LifeWhere Portal" }, () => {
            this.showTTConfirmModal();
        });
    }

    onTTConfirm() {
        Event("View Device Properties Clicked", "User clicked view device properties and is being taken to TwinThread Properties view", "View Device Properties Clicked");
        window.open(this.state.devTTUrl, '_blank'); // opens new tab with TwinThread twins detail page
        this.showTTConfirmModal(); // closes modal
    }

    showDiagnosticsTestModal() {
        this.setState({
            showDiagnosticsTest: !this.state.showDiagnosticsTest
        }, () => {
            if (this.state.showDiagnosticsTest) {
                ModalView("diagnosticsTest");
            }
        });
    }

    openDiagnosticsTestModal() {
        if (this.state.isSelected !== -1 && this.state.currentDevice !== jsDevice) {
            this.setState({ showDiagnosticsTest: true });
        }
    }

    showDiagnosticsModal() {
        this.setState({
            showDiagnostics: !this.state.showDiagnostics
        }, () => {
            if (this.state.showDiagnostics) {
                ModalView("diagnostics");
            }
        });
    }
    
    openDiagnosticsModal() {
        if (this.state.isSelected !== -1 && this.state.currentDevice !== jsDevice) {
            this.setState({ showDiagnostics: true, diagnosticsLoading: true }, async () => {
                let nowMoment = moment().utc();
                await AssetService.getgatewayrebootcodes(this.state.currentAsset.assetId, nowMoment.format().toString())
                    .then(response => {
                        this.setState({ gatewayRebootCodes: response.data, diagnosticsLoading: false });
                    })
                    .catch(e => {
                        console.log(e);
                    })
            });
        }
    }

    showRepairSensorMapModal() {
        this.setState({
            showRepairSensorMap: !this.state.showRepairSensorMap,
            sensorList: [],
            currentSensor: null,
            mappedSensors: [],
            unmappedProperties: [],
            mapDict: {},
        }, () => {
            if (this.state.showRepairSensorMap) {
                ModalView("repairSensorMapConfirm");
            }
        });
        window.scrollTo(0, 0);
    }

    openRepairSensorMapModal() {
        if (this.state.isSelected !== -1 && this.state.currentDevice !== jsDevice) {
            this.setState({ sensorsLoading: true, showRepairSensorMap: true }, async () => {
                await DeviceService.getsensormapitems(this.state.currentDevice.mac.split('-')[0])
                    .then(response => {
                        if (this._isMounted) {
                            let sensors = response.data;
                            let isMultiCT = this.state.isFlyCatcher; 

                            let unmappedProps = this.getMapProperties(this.state.currentAsset.properties, isMultiCT);
                            let mapDict = {};
                            let currentSensor = null;
                            let mappedSensors = [];
                            if (sensors !== null && sensors !== undefined && sensors.length) {
                                if (isMultiCT) {
                                    let flycatcherProps = this.state.currentAsset.type === Equipment.AIR_CONDITIONER || this.state.currentAsset.type === Equipment.FURNACE ? FLYCATCHER_PROP_DICT[this.state.currentAsset.type] : [];
                                    mappedSensors = sensors.filter(s => (flycatcherProps.find(f => s.mappedTo.includes(f)) !== undefined) && s.mappedTo.includes(this.state.currentDevice.deviceId.trim()));
                                }
                                else {
                                    mappedSensors = sensors.filter(s => s.mappedTo.includes(" Current") && s.mappedTo.includes(this.state.currentDevice.deviceId)); 
                                }

                                if (mappedSensors !== null && mappedSensors !== undefined && mappedSensors.length) {
                                    currentSensor = mappedSensors.find(m => m.mappedTo.includes(this.state.currentDevice.deviceId));
                                }

                                sensors = sensors.filter(s => s.status === "Unmapped");
                                mapDict = unmappedProps.map((prop, index) => {
                                    return -1;
                                });
                            }

                            this.setState({
                                sensorList: sensors,
                                currentSensor: currentSensor,
                                mappedSensors: mappedSensors,
                                unmappedProperties: unmappedProps,
                                mapDict: mapDict,
                                sensorsLoading: false
                            });
                        }
                    })
            })
        }
    }
    
    getDiagnosticPropertyValue(assetProperties, propertyName) {
        let value = '';
        
        if (assetProperties !== null && assetProperties !== undefined && assetProperties.length && assetProperties.findIndex(p => p.name === propertyName) !== -1) {
            let diagnosticProp = assetProperties.find(prop => prop.name === propertyName);
            value = diagnosticProp.valueRaw;
        }
        
        return value;
    }

    getMapProperties(assetProperties, isMultiCT = true) {
        let props = [];
        let currentProps = [];
        if (isMultiCT) {
            let flycatcherProps = this.state.currentAsset.type === Equipment.AIR_CONDITIONER || this.state.currentAsset.type === Equipment.FURNACE ? FLYCATCHER_PROP_DICT[this.state.currentAsset.type] : [];
            currentProps = assetProperties.filter(p => flycatcherProps.includes(p.name));
        }
        else {
            currentProps = assetProperties.filter(p => p.name === "Current");
        }
        props = currentProps;

        return props;
    }

    mapSensor(propertyIndex, sensorIndex) {
        let mapDict = this.state.mapDict;
        mapDict.forEach((item, index) => {
            if (index === propertyIndex) {
                mapDict[index] = sensorIndex;
            }
            else if (mapDict[index] === sensorIndex) {
                mapDict[index] = -1;
            }
        });

        this.setState({ mapDict: mapDict });
    }

    updateSensorMap() {
        this.setState({ loading: true , sensorsLoading : true}, () => {
            if (this.state.currentDevice !== null && this.state.currentDevice !== undefined && this.state.currentDevice.deviceId !== "") {
                let sensorDict = {}; 
                for (let i = 0; i < this.state.unmappedProperties.length; i++) {
                    if (this.state.mapDict[i] !== -1) {
                        let sensor = this.state.sensorList[this.state.mapDict[i]];
                        let property = this.state.unmappedProperties[i];
                        sensorDict[property.name] = sensor; 
                    }
                }

                DeviceService.repairsensormap(this.state.currentHVACSystem.id, this.state.currentDevice.mac, sensorDict)
                    .then(response => {
                        let message = "";

                        if (response.data === true) {
                            message = "Successfully repaired Sensor Map!";
                            Event("Repair Sensor Map Clicked", "User clicked repair sensor map button", "Repair Sensor Map Clicked");
                            this.setState({ statusMessage: message, showRepairSensorMap: false }, async () => {
                                this.setDevices(this.state.currentHVACSystem);
                            })
                        }
                        else {
                            message = "Failed to repair Sensor Map!";

                            this.setState({ statusMessage: message, loading: false, showRepairSensorMap: false });
                        }

                    }).catch(e => {
                        console.log(e);
                    });
            }
            else {
                let message = "No Device selected!";
                this.setState({ statusMessage: message, loading: false, showRepairSensorMap: false });
            }
        });
    }

    getDate(str) {
        var date = "";
        if (moment(str).isValid()) {
            return moment.utc(str).local().format("l h:mm:ss A");
        }
        return (date);
    }

    getSigStamp(str) {
        var date = "";
        if (moment(str).isValid()) {
            return moment.utc(str).local().format("[on] MMM Do, YYYY [at] h:mm A");
        }
        return (date);
    }

    getSigStampAlone(str) {
        var date = "";
        if (moment(str).isValid()) {
            return moment.utc(str).local().format("MMM Do, YYYY [at] h:mm A");
        }
        return (date);
    }
    
    getTimespanStr(str) {
        let timespanStr = "";
        let timestamp = "";
        let date = "";
        
        if (moment(str).isValid()) {
            date = moment.utc(str).local();
            timestamp = moment.utc(str).local().format("MMM Do, YYYY [at] h:mm A");
        }
        
        let now = moment().utc().local();
        let timeDiff = moment.duration(now.diff(date));
        
        if (timeDiff.isValid()) {
            if (timeDiff.asHours() < 1) {
                timespanStr = " (< 1 hour ago)";
            }
            else if (timeDiff.asHours() < 2) {
                timespanStr = " (" + Math.floor(timeDiff.asHours()) + " hour ago)";
            }
            else if (timeDiff.asHours() < 48) {
                timespanStr = " (" + Math.floor(timeDiff.asHours()) + " hours ago)";
            }
            else if (timeDiff.asDays() < 30) {
                timespanStr = " (" + Math.floor(timeDiff.asDays()) + " days ago)";
            }
            else if (timeDiff.asMonths() < 12) {
                timespanStr = " (" + Math.floor(timeDiff.asMonths()) + " months ago)";
            }
            else if (timeDiff.asYears() < 2) {
                timespanStr = " (" + Math.floor(timeDiff.asYears()) + " year ago)";
            }
            else {
                timespanStr = " (" + Math.floor(timeDiff.asYears()) + " years ago)";
            }
        }
        
        return timestamp + timespanStr;
    }

    delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    refreshAllStatus() {
        var statusUpdateList = [];
        for (let i = 0; i < this.state.deviceList.length; i++) {
            statusUpdateList[i] = true;
            this.refreshStatus(i);
        }
        this.setState({ statusLoadingList: statusUpdateList })
    }

    setUpPagination(selectedTab) {
        let tableList;
        let pageCount = 1;
        let startIndex = 0;
        let page = null;
        let endIndex = 0;
        switch (selectedTab) {
            case 0:
                tableList = this.state.logListGateway;
                if (tableList.length > PageSize) {
                    pageCount = Math.ceil(tableList.length / PageSize);
                }
                endIndex = (this.state.currentPageGateway * PageSize) - 1;
                if (this.state.logListGateway !== null && this.state.logListGateway !== undefined) {
                    page = this.state.logListGateway.slice(startIndex, endIndex);
                }
                this.setState({ pageCountGateway: pageCount, paginglogListGateway: page });
                break;

            case 1:
                tableList = this.state.logListSH1;
                if (tableList.length > PageSize) {
                    pageCount = Math.ceil(tableList.length / PageSize);
                }
                endIndex = (this.state.currentPageSH1 * PageSize) - 1;
                if (this.state.logListSH1 !== null && this.state.logListSH1 !== undefined) {
                    page = this.state.logListSH1.slice(startIndex, endIndex);
                }
                this.setState({ pageCountSH1: pageCount, paginglogListSH1: page });
                break;

            case 2:
                tableList = this.state.logListSH2;
                if (tableList.length > PageSize) {
                    pageCount = Math.ceil(tableList.length / PageSize);
                }
                endIndex = (this.state.currentPageSH2 * PageSize) - 1;
                if (this.state.logListSH2 !== null && this.state.logListSH2 !== undefined) {
                    page = this.state.logListSH2.slice(startIndex, endIndex);
                }
                this.setState({ pageCountSH2: pageCount, paginglogListSH2: page });
                break;
        }
    }

    onChangePage(e, page) {
        let pageSelected = parseInt(e.target.innerText, 10);
        if (this._isMounted)
            switch (page) {
                case 0:
                    this.setState({ currentPageGateway: pageSelected }, () => {
                        this.getPageList(page);
                    });
                    break;
                case 1:
                    this.setState({ currentPageSH1: pageSelected }, () => {
                        this.getPageList(page);
                    });
                    break;
                case 2:
                    this.setState({ currentPageSH2: pageSelected }, () => {
                        this.getPageList(page);
                    });
                    break;

            }
    }

    getPageList(selectedgateway) {
        let page = null;
        let endIndex = 0;
        let startIndex = 0;
        switch (selectedgateway) {
            case 0:
                endIndex = (this.state.currentPageGateway * PageSize) - 1;
                startIndex = (this.state.currentPageGateway - 1) * PageSize;

                if (this.state.logListGateway !== null && this.state.logListGateway !== undefined) {
                    page = this.state.logListGateway.slice(startIndex, endIndex);
                }

                this.setState({ paginglogListGateway: page });
                break;
            case 1:
                endIndex = (this.state.currentPageSH1 * PageSize) - 1;
                startIndex = (this.state.currentPageSH1 - 1) * PageSize;

                if (this.state.logListSH1 !== null && this.state.logListSH1 !== undefined) {
                    page = this.state.logListSH1.slice(startIndex, endIndex);
                }

                this.setState({ paginglogListSH1: page });
                break;
            case 2:
                endIndex = (this.state.currentPageSH2 * PageSize) - 1;
                startIndex = (this.state.currentPageSH2 - 1) * PageSize;

                if (this.state.logListSH2 !== null && this.state.logListSH2 !== undefined) {
                    page = this.state.logListSH2.slice(startIndex, endIndex);
                }

                this.setState({ paginglogListSH2: page });
                break;
        }
    }


    async refreshStatus(index) {
        Event("Refresh Status Clicked", "User refreshed status in Devices page", "Refresh Status Clicked");
        let loadingCheck = [];
        let assetId = parseInt(this.state.deviceList[index].parentId, 10);
        let startDateInt = new Date().getTime();

        this.setState(prevState => ({
            statusLoadingList: {
                ...prevState.statusLoadingList,
                [index]: true
            }
        }));
        this.setState({ statusLoading: true, isTimeout: false, updateStatusProgress: "Running Status Update" });

        // Get the Asset Links and find the Device Status_LPX Thread details
        await AssetService.getassetlinks(assetId)
            .then(response1 => {
                if (response1.data.threads && response1.data.threads.length > 0) {
                    var assetThreads = response1.data.threads;
                    var deviceStatusThreads = assetThreads.filter(a => a.name === DEVICE_STATUS_THREAD_NAME);
                    if (deviceStatusThreads && deviceStatusThreads.length > 0) {
                        this.setState({ deviceStatusThread: deviceStatusThreads }, async () => {
                            // Run the Device Status_LPX Thread
                            await threadService.runthread(deviceStatusThreads[0].threadId)
                                .then(response2 => {
                                    if (response2 && response2.blockDebugInfo && response2.blockDebugInfo.length > 0 && response2.blockDebugInfo[0].outputs.length > 0) {
                                        this.setState({ deviceStatusThread: deviceStatusThreads }, async () => {
                                            // Get Properties to find Status property
                                            await AssetService.getpropertydatalist(assetId)
                                                .then(response3 => {
                                                    let statusProp = response3.data.find(prop => prop.name === STATUS_PROP_NAME);
                                                    //let updateTime = statusProp.timestamp;
                                                    //let updateTimestamp = new Date(parseInt(updateTime.match(/\d+/)[0], 10));
                                                    //let updateTimeInt = updateTimestamp.getTime();
                                                    let startDate = new Date(startDateInt);
                                                    let endDate = new Date();

                                                    let trendDataRequest = {
                                                        assetId: parseInt(assetId, 10),
                                                        propertyList: [parseInt(statusProp.propertyId, 10)],
                                                        startTime: startDate.toISOString(),
                                                        endTime: endDate.toISOString(),
                                                        maxPoints: 10,
                                                        summaryType: 11
                                                    };
                                                    // Get the Status Property Trend Data
                                                  AlertService.getstringtrenddata(trendDataRequest)
                                                        .then(response4 => {
                                                            if (response4.data && response4.data.length > 0) {
                                                                let latestTimestamp = response4.data[0].timestamps[response4.data[0].timestamps.length - 1];
                                                                let latestTimestampInt = new Date(latestTimestamp).getTime();
                                                                // If the Status property was updated since the start of this process, then we have the latest Status value
                                                                if (startDateInt < latestTimestampInt) {
                                                                    let devices = this.state.deviceList;
                                                                    devices[index].status = response4.data[0].values[response4.data[0].values.length - 1];
                                                                    this.setState(prevState => ({
                                                                        statusLoadingList: {
                                                                            ...prevState.statusLoadingList,
                                                                            [index]: false
                                                                        }
                                                                    }),() =>{
                                                                    this.setState({ isUpdated: true, deviceList: devices });
                                                                    loadingCheck = this.state.statusLoadingList;
                                                                    let isDoneLoading = Object.keys(loadingCheck).filter(key => loadingCheck[key]).every(v => v === false);
                                                                    if (isDoneLoading) {
                                                                        this.setState({ updateStatusProgress: "Successfully Updated Status!" }, async () => {
                                                                            await this.delay(1000);
                                                                            this.setState({ statusLoading: false, updateStatusProgress: "" });
                                                                        });
                                                                    }
                                                                    });
                                                                }
                                                            }

                                                        });
                                                })
                                                .catch(e => {
                                                    console.log(e);
                                                    this.failedDeviceStatusUpdate(index);
                                                });

                                        });
                                    }
                                    else {
                                        this.failedDeviceStatusUpdate(index);
                                    }
                                })
                                .catch(e => {
                                    console.log(e);
                                    this.failedDeviceStatusUpdate(index);
                                });
                        });
                    }
                    else {
                        this.failedDeviceStatusUpdate(index);
                    }
                }
                else {
                    this.failedDeviceStatusUpdate(index);
                }
            })
            .catch(e => {
                console.log(e);
                this.failedDeviceStatusUpdate(index);
            });
    }

    failedDeviceStatusUpdate(index) {
        this.setState(prevState => ({
            statusLoadingList: {
                ...prevState.statusLoadingList,
                [index]: false
            }
        }));
        this.setState({ updateStatusProgress: "Failed to Update Status" }, async () => {
            await this.delay(1000);
            this.setState({ statusLoading: false, updateStatusProgress: "" });
        });
    }

    getDeviceStatus(index) {
        if (this.state.statusLoadingList[index]) {
            return (
                <Spinner animation="border" variant="dark" />
            );
        }
        else {
            let deviceStatus = this.state.deviceList[index].status;
            return (
                <span href="#" id="TooltipStatus">{deviceStatus}
                    <RefreshIcon onClick={() => { this.refreshStatus(index) }} />
                </span>
            );
        }
    }

    getRepairButtonDisabled() {
        let disabled = false;

        if (this.state.isSelected === -1 || this.state.currentDevice === null || this.state.currentDevice === undefined || this.state.currentDevice.sensorMap === undefined) {
            disabled = true;
        }

        return disabled;
    }
    
    getViewButtonDisabled() {
        let disabled = true;
        if (!this.state.viewLoading) {
            disabled = false
        }
        return disabled;
    }

    getDateString(date) {
        let dateStr = moment(date).format('YYYY-MM-DD hh:mm:ss a');

        return dateStr;
    }
    async refreshorgetDevicelogs() {
        let macIdList = [];
        let deviceId = this.state.selectedDeviceId;
        let devices = this.state.assetList;
        let deviceConfig = this.state.deviceConfiguration;
        let deviceConfigObj = this.state.deviceConfiguration != "" && JSON.parse(this.state.deviceConfiguration);
        for (var keyName of Object?.keys(deviceConfigObj)) {
            if (keyName == 'mac') {
                macIdList.push(deviceConfigObj?.mac);
            }

            if (keyName == 'lpxs') {
                if (deviceConfigObj?.lpxs?.length > 0) {
                    for (var lpx of deviceConfigObj?.lpxs) {
                        if (lpx?.mac !== undefined && lpx?.mac !== null) {
                            macIdList.push(lpx?.mac);
                        }
                    }
                }
            }

        }

        let devicemac = deviceConfigObj?.lpxs?.find(x => x.id == this.state.selectedDeviceId.split("-")[1])?.mac;
        //let devicemacId = devicemac.find(x => x.id == this.state.selectedDeviceId.split("-")[2])

        await AlertService.getdevicegraphdata(this.state.startDateTimeStrPlus, this.state.endDateTimeStrPlus, devices)
            .then(response => {
                if (response.data !== null) {
                    this.setState({
                        deviceGraph: response.data,
                        loading: false,
                        configLoading: false
                    })
                }
            }).catch(e => {
                this.setState({
                    loading: false,
                    configLoading: false
                });
            });

        if (macIdList !== undefined && devicemac !== null && macIdList.length > 0) {
            macIdList.forEach(async (mac, i) => {
                await DeviceRequestsService.getdevicerequests(mac)
                    .then(response => {
                        if (response.data != null) {
                            switch (i) {
                                case 0:
                                    this.setState({
                                        logListGateway: response.data?.reverse(),

                                    }, () => {
                                        this.getFirmwareData();
                                        this.setUpPagination(i);
                                    });
                                    break;
                                case 1:
                                    this.setState({
                                        logListSH1: response.data?.reverse(),

                                    }, () => {

                                        this.setUpPagination(i);
                                    });
                                    break;
                                case 2:
                                    this.setState({
                                        logListSH2: response.data?.reverse(),

                                    }, () => {

                                        this.setUpPagination(i);
                                    });
                                    break;
                            }
                           

                        }
                    }
                    )
                    .catch(e => {
                        console.log(e);
                        this.setState({
                            configLoading: false
                        });
                    });
            });
        }
        else {
            this.setState({
                logList: [],
                paginglogList: [],
                searchLoading: false,
                loading: false,
                configLoading: false
            });
        }

    }

    onChangeStart(e) {
        var start = moment(e).toDate();
        var startStr = moment(e).utc().format();
        this.setState({ dpStartDateTime: start, startDateTimeStrPlus: startStr });
    }

    onChangeEnd(e) {
        var end = moment(e).toDate();
        var endStr = moment(e).utc().format();
        this.setState({ dpEndDateTime: end, endDateTimeStrPlus: endStr });
    }

    handleCheckbox(e) {
        const checkedVal = e.target.value;

        if (e.target.checked) {
            this.setState(prevState => ({
                visibility: {
                    ...prevState.visibility,
                    [checkedVal]: true
                }
            }));
        }
        else {
            this.setState(prevState => ({
                visibility: {
                    ...prevState.visibility,
                    [checkedVal]: false
                }
            }));
        }
    }

    populateAssetData() {
            var now = moment();
            var before = moment(now).add(-1, 'hours');
            var beforeStr = before.utc().format();
            var nowStr = now.utc().format();
            var dpSTR = before.toDate();    //date picker string 
            var dpSTR2 = now.toDate();     // date picker string end
            this.setState({ loading: true, dpStartDateTime: dpSTR, startDateTimeStrPlus: beforeStr, dpEndDateTime: dpSTR2, endDateTimeStrPlus: nowStr }, async () => {
                if (this.props.currentCustomerId === "-1") {
                    this.setState({ loading: false });
                }
            });
    }
    
    getdeviceodel()
    {
        const tags = this.state.devicetags;
        const deviceclasses   = this.state.deviceAppliedClasses;
      
        let deviceType = "";
    
            if(tags.length > 0 && deviceclasses.length > 0  && tags?.some(x => (x.name == jsdevicetags.diagnostiqtag)) && deviceclasses?.some(x => x.name == jsdeviceClass.diagnostiqclass))
            {
                deviceType = jsdeviceModels.diagnostiq;
            }
            else if(tags.length > 0 && deviceclasses.length > 0  && tags?.some(x => x.name == jsdevicetags.denalitag) && deviceclasses?.some(x => x.name == jsdeviceClass.denaliClass))
            {
                deviceType = jsdeviceModels.denali;
            }
            else if(deviceclasses.length > 0  && deviceclasses?.some(x => x.name == jsdeviceClass.lpxclass) ) {
                deviceType = jsdeviceModels.lpx;
            }
            else
            {
                deviceType = "";
            }
        return deviceType;
    }
    
    getDataObj(name, dataArr, pointStart, color, yAxis) {
        return {
            name: name,
            data: dataArr,
            color: color,
            type: 'line',
            zIndex: 0,
            pointStart: pointStart,
            pointInterval: 1000,
            yAxis: yAxis
        };
    }

    extendData(prevGraphData, newGraphData) {
        let returnGraphData = prevGraphData;
        if (prevGraphData !== null && prevGraphData !== undefined && newGraphData !== null && newGraphData !== undefined) {
            for (let i = 0; i < prevGraphData.length; i++) {
                let macId = this.state.assetList[i].name;
                
                let prevData = prevGraphData[i];
                let prevDataList = prevGraphData[i].dataArray[macId];
                let newDataList = newGraphData[i].dataArray[macId];
                
                let dataKeys = Object.keys(prevDataList);
                for (let j = 0; j < dataKeys.length; j++) {
                    let prevDataObj = prevDataList[dataKeys[j]];
                    let newDataObj = newDataList[dataKeys[j]];
                    
                    prevDataObj.timestamps = newDataObj.timestamps.concat(prevDataObj.timestamps);
                    prevDataObj.values = newDataObj.values.concat(prevDataObj.values);
                    prevDataList[dataKeys[j]] = prevDataObj;
                }
                prevData.dataArray[macId] = prevDataList;
                prevData.startTime = newGraphData[i].startTime;
                prevData.startTimeStr = newGraphData[i].startTimeStr;
                prevGraphData[i] = prevData;
            }
            returnGraphData = prevGraphData;
        }
        return returnGraphData;
    }
    onExtendDataLeft() {
        let newLeftHours = this.state.leftHours + 1; //1 'hr' = 30 minutes
        
        this.setState({ leftHours: newLeftHours, extendedLoading: true }, async () => {
            let leftMinutes = newLeftHours*-30;
            let extendedStartTime = moment(this.state.startDateTimeStrPlus).add(leftMinutes, 'minutes');
            let extendedEndTime = moment(this.state.startDateTimeStrPlus).add(leftMinutes + 30, 'minutes');
            
            await AlertService.getdevicegraphdata(extendedStartTime.utc().format(), extendedEndTime.utc().format(), this.state.assetList)
                .then(response => {
                    if (response.data !== null) {
                        let newDevGraph = response.data;
                        let devGraph = this.extendData(this.state.deviceGraph, newDevGraph);
                        
                        this.setState({
                            deviceGraph: devGraph,
                            loading: false,
                            extendedLoading: false
                        })
                    }
                }).catch(e => {
                    this.setState({
                        loading: false,
                        extendedLoading: false
                    });
                });
        });
    }

    getHighchartsTimelineData() {
        let timelineDataList = [];
        let batteryArr = this.state.deviceGraph?.find(x => (x.deviceId === this.state.selectedDeviceId));

        if (this.state.deviceGraph?.length >= 0 && this.state.deviceGraph?.find(x => (x.deviceId === this.state.selectedDeviceId) != null) && batteryArr != null) {
            {
                let pointMoment = moment(batteryArr.startTime).add(moment().utcOffset() * -1, 'minutes').format("l h:mm:ss A");
                let dt = new Date(pointMoment);
                let pointStartDT = Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate(), dt.getHours(), dt.getMinutes(), dt.getSeconds(), dt.getMilliseconds());

                if (this.state.visibility.wifirssi) {
                    let value = batteryArr.dataArray[batteryArr.deviceId]["device_WifiRSSI"]?.values
                    let batteryData = this.getDataObj('WiFi', value, pointStartDT, '#556b2f', 1); 
                    timelineDataList = timelineDataList.concat(batteryData);

                }
                if (this.state.visibility.subgrssi) {
                    let value = batteryArr.dataArray[batteryArr.deviceId]["device_subgRSSI"]?.values
                    let batteryData = this.getDataObj('SensorHub', value, pointStartDT, '#8b0000', 1);
                    timelineDataList = timelineDataList.concat(batteryData);
                }
                if (this.state.visibility.batteryVoltage) {
                    let value = batteryArr.dataArray[batteryArr.deviceId]["device_batteryvoltage"]?.values
                    let batteryData = this.getDataObj('Battery Voltage', value, pointStartDT, '#dc3545', 0);
                    timelineDataList = timelineDataList.concat(batteryData);
                }
                if (this.state.visibility.current) {
                    let value = batteryArr.dataArray[batteryArr.deviceId]["device_current"]?.values
                    let batteryData = this.getDataObj('Current', value, pointStartDT, '#f0b169', 0);
                    timelineDataList = timelineDataList.concat(batteryData);
                }
                if (this.state.visibility.devicetemperature) {
                    let value = batteryArr.dataArray[batteryArr.deviceId]["device_temp"]?.values
                    let batteryData = this.getDataObj('Temperature', value, pointStartDT, '#176a95', 1);
                    timelineDataList = timelineDataList.concat(batteryData);
                }
                if (this.state.visibility.gatewayResets) {
                    let value = batteryArr.dataArray[batteryArr.deviceId]["device_gatewayResets"]?.values
                    let gatewayResetsData = this.getDataObj('Gateway Resets', value, pointStartDT, '#7d80f3', 0);
                    timelineDataList = timelineDataList.concat(gatewayResetsData);
                }
                if (this.state.visibility.gatewayRebootOverflow) {
                    let value = batteryArr.dataArray[batteryArr.deviceId]["device_gatewayRebootOverflow"]?.values
                    let gatewayRebootOverflowData = this.getDataObj('Gateway Reboot Overflow', value, pointStartDT, '#b67df3', 0);
                    timelineDataList = timelineDataList.concat(gatewayRebootOverflowData);
                }
            }

        }
        return timelineDataList;
    }
    
    handleViewInstallCheckReportsClicked() {
        this.setState({ showHistoricalInstallChecks: !this.state.showHistoricalInstallChecks });
    }

    onRemoveMappedSensor = (mappedSensor) => {
        let mappingProperty = this.state.currentAsset.properties.find(x => x.propertyId === mappedSensor.mappedToId);
        let secondProperty = this.state.mappedSensors.find(sensor => sensor.name === mappedSensor.name);
        let unmapList = [];
        let unmapSecond = {
            propertyId: secondProperty.mappedToId,
            name: mappingProperty.name,
            description: mappingProperty.name,
            friendlyId:mappingProperty?.friendlyId,
            dataIndexId: secondProperty.indexId,
            dataIndexName: secondProperty.name,
            assetId: this.state.currentAsset.assetId
        };
        unmapList.push(unmapSecond);
       
        DeviceService.unmapproperties(unmapList)
            .then(async response => {
                   
                })
            .catch(e => {
                console.log(e);
                this.setState({ loading: true });
            }).finally(
                () => { this.openRepairSensorMapModal();}
        )
    }
    
    renderGraphButtons() {
        let checkboxes =
            <div className="radio-container graph-radio-container">
                <div>
                    <input type="checkbox" value="wifirssi" checked={this.state.visibility.wifirssi} id="id_wifirssi" onChange={this.handleCheckbox} />
                    &nbsp; Wifi &nbsp;&nbsp;
                </div>
                <div>
                    <input type="checkbox" value="subgrssi" checked={this.state.visibility.subgrssi} id="id_subgrssi" onChange={this.handleCheckbox} />
                    &nbsp; 	SensorHub &nbsp;&nbsp;
                </div>
                <div>
                    <input type="checkbox" value="batteryVoltage" checked={this.state.visibility.batteryVoltage} id="id_batteryVoltage" onChange={this.handleCheckbox} />
                    &nbsp; Battery Voltage &nbsp;&nbsp;
                </div>
                <div>
                    <input type="checkbox" value="current" checked={this.state.visibility.current} id="id_current" onChange={this.handleCheckbox} />
                    &nbsp; Current &nbsp;&nbsp;
                </div>
                <div>
                    <input type="checkbox" value="devicetemperature" checked={this.state.visibility.devicetemperature} id="id_devicetemperature" onChange={this.handleCheckbox} />
                    &nbsp; Temperature &nbsp;&nbsp;
                </div>
                <div>
                    <input type="checkbox" value="gatewayResets" checked={this.state.visibility.gatewayResets} id="id_gatewayResets" onChange={this.handleCheckbox} />
                    &nbsp; Gateway Resets &nbsp;&nbsp;
                </div>
                <div>
                    <input type="checkbox" value="gatewayRebootOverflow" checked={this.state.visibility.gatewayRebootOverflow} id="id_gatewayRebootOverflow" onChange={this.handleCheckbox} />
                    &nbsp; Gateway Reboot Overflow &nbsp;&nbsp;
                </div>
            </div>
        let viewRunsButton = !this.state.thermostatSelected ?
            <div className="row centered">
                <button type="button" className="margin-top-10 secondary-btn btn-small" onClick={this.onViewRuns} disabled={this.getViewButtonDisabled()}>View </button>
            </div>
            : null;
        return (
            <div>
                {viewRunsButton}
                <hr />
                <div className="lastItem">
                    <div className="detailTitle">Graph Display Options</div>
                    {checkboxes}
                </div>
            </div>
        );
    }
    renderGraph() {
        let rightCol =
            <div className="col-sm-12 col-md-4">
                <div className="grey-container">
                    <h5 className="sectionTitle">
                        Graph Options
                    </h5>
                    <div className="row">
                        <div className="col-sm-2 col-md-6 col-lg-3 col-xl-2">
                            <div className={"margin-left-10"}>Start:</div>
                        </div>
                        <div className="col-sm-9 col-md-12 col-lg-9 centered center">
                            <DatePicker
                                customInput={<input className="txt-detail asset-select-datepicker" disabled={this.state.disableGraphOptions} />}
                                id="startDate"
                                name="startDate"
                                selected={this.state.dpStartDateTime}
                                onChange={date => { Event("Run Start Date Click", "User clicked start date picker to change it", "Run Start Date Changed"); this.onChangeStart(date); }}
                                dateFormat="MM/dd/yyyy h:mm:ss aa"
                                timeIntervals={15}
                                showTimeSelect
                                popperPlacement="top-end"
                                popperProps={{
                                    positionFixed: true
                                }}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-2 col-md-6 col-lg-3 col-xl-2">
                            <div className={"margin-left-10"}>End:</div>
                        </div>
                        <div className="col-sm-9 col-md-12 col-lg-9 centered center">
                            <DatePicker
                                customInput={<input className="txt-detail asset-select-datepicker margin-bottom-0" disabled={this.state.disableGraphOptions} />}
                                id="endDate"
                                name="endDate"
                                selected={this.state.dpEndDateTime}
                                onChange={date => { Event("Run End Date Click", "User clicked end date picker to change it", "Run End Date Changed"); this.onChangeEnd(date); }}
                                dateFormat="MM/dd/yyyy h:mm:ss aa"
                                timeIntervals={15}
                                showTimeSelect
                                popperPlacement="top-end"
                                minDate={this.state.dpStartDateTime}
                                maxDate={addHours(this.state.dpStartDateTime, 48)}
                                popperProps={{
                                    positionFixed: true
                                }}
                            />
                        </div>
                    </div>
                    {this.renderGraphButtons()}
                </div>
                <br /><br />
            </div>;
        let deviceGraph = (this.state.deviceGraph && true && true && !this.state.configLoading) ?
            <div className={"graph-assets"}>
                <GraphComponent graphType={GraphTypes.ASSET} chartData={this.getHighchartsTimelineData()} assetType={Equipment.AIR_CONDITIONER} visibility={this.state.visibility}
                    secondAxisType={this.state.visibility.devicetemperature ? AxisTypes.TEMP : this.state.visibility.subgrssi || this.state.visibility.wifirssi ? AxisTypes.WIFI : AxisTypes.NONE}
                />

            </div>
            : <div className={"graph-assets-noData"}>
                {
                    "There is no data for this unit or loading data"
                }
                <br /><br />
            </div>;
        let extendedLeftButton = <div className={"extended-icon extended-left col-sm-1 col-md-1"}>
            <IconButton onClick={this.onExtendDataLeft}>
                <i className={"fa-solid fa-arrow-left extended-color"}></i>
            </IconButton>
        </div>

        let devicePanel = (this.state.deviceGraph && this.state.deviceGraph != null && this.state.deviceGraph !== undefined && this.state.deviceGraph.length > 0) ?
            <div className="row">
                <div className="col-sm-12 col-md-8">
                    <div className="row">
                        {extendedLeftButton}
                        <div className={"margin-top-10 margin-right-15 col-sm-10 col-md-10"} >
                            {deviceGraph}

                            <br /><br />
                        </div>
                    </div>
                </div>
                {rightCol}
            </div>
            : <div className="row">
                <div className="col-sm-12 col-md-8">
                    <div className={"margin-top-10 margin-left-15 margin-right-15"}>
                        No data within selected time frame. The unit is either not running or not sending data. Check the Devices page to verify the status of the LifeWhere devices.
                        <br /><br />
                    </div>
                </div>
            </div>;

        let otaserver = <div className="row">
            <div className="col-sm-12 col-md-8">
                <div className={"margin-top-10 margin-left-15 margin-right-15"}>
                    <br /> <br />
                    Gateway version: {this.state.firmware.gatewayversion}
                    <br /> <br />
                    Last 24 hours Gateway has checked in with the OTA server :  {this.state.firmware.gatewayLoggedin}
                    <br /> <br />
                    Firmware version: {this.state.firmware.firmwareversion}
                    <br /> <br />
                    Last 24 hours the SH has checked in with the OTA server :  {this.state.firmware.serverLoggedin}
                    <br /> <br />
                    Firmware loaded {this.state.firmware.shtype} and associated class are {this.state.firmware.class}
                    <br /> <br />
                    Reprovosion Result : {this.state.firmware.reprovosionresult}
                    <br /> <br />
                </div>
            </div>
        </div>;

        return (
            <Tabs>
                <TabList className={"margin-top-10 pad-left-15"} >
                    <Tab>Graph</Tab>
                    <Tab>OTA Server</Tab>
                </TabList>

                <TabPanel>
                    {devicePanel}
                </TabPanel>
                <TabPanel>
                    {otaserver}
                </TabPanel>
            </Tabs>
        );
    }
    renderDevices(deviceList) {
        const { classes } = this.props;
        let configLoader = this.state.configLoading ?
            <Loader />
            : <div>{null}</div>;

        let contents = <tbody>
            <tr>
                <td>No Devices</td>
            </tr>
        </tbody>;
        let thermostatContents = null;
        let contentforGatewayLogs = <tbody>
            <tr>
                <td>No Devices Logs</td>
            </tr>
        </tbody>;
        let contentforSH1Logs = <tbody>
            <tr>
                <td>No Devices Logs</td>
            </tr>
        </tbody>;

        let contentforSH2Logs = <tbody>
            <tr>
                <td>No Devices Logs</td>
            </tr>
        </tbody>;

        if (this.state.isSystemChanged && this.state.currentHVACSystem.children.length) {
            contents = <tbody>
                <tr>
                    <td>Loading Devices...</td>
                </tr>
            </tbody>;
            contentforGatewayLogs = <tbody>
                <tr>
                    <td>Loading Devices Logs...</td>
                </tr>
            </tbody>;
        } else if (deviceList.length) {

            const thermostatAssetIds = new Set(
                this.state.assetList.filter(a => a.type.trim() === "Thermostat").map(a => String(a.assetId))
            );
            thermostatContents = <tbody>
                {deviceList.map((device, index) =>
                    thermostatAssetIds.has(device.parentId) ? (
                        <tr id={device.parentId} key={device.parentId}>
                            <td onClick={() => { this.onAssetClick(index, device.parentId) }} className={this.state.isSelected === index ? "tableSelected" : ""}>{device.deviceType}</td>
                            <td onClick={() => { this.onAssetClick(index, device.parentId) }} className={this.state.isSelected === index ? "tableSelected" : ""}>{device.mac}</td>
                            <td onClick={() => { this.onAssetClick(index, device.parentId) }} className={this.state.isSelected === index ? "tableSelected" : ""}>{device.nickname}</td>
                        </tr>
                    ) : null
                )}
            </tbody>;
            contents =
                <tbody>
                    {deviceList?.map((device, index) =>
                        !thermostatAssetIds.has(device.parentId) ? (
                        <tr id={device.parentId} key={device.parentId} onContextMenu={(event) => this.handleContextMenu(event, device.parentId)}>
                            <td onClick={() => {
                                this.onAssetClick(index , device.parentId)
                            }} className={this.state.isSelected === index ? "tableSelected" : ""}>{device.deviceType}</td>
                            <td onClick={() => {
                                this.onAssetClick(index, device.parentId)
                            }} className={this.state.isSelected === index ? "tableSelected" : ""}>{device.mac}</td>
                            <td onClick={() => {
                                this.onAssetClick(index, device.parentId)
                            }} className={this.state.isSelected === index ? "tableSelected" : ""}>{device.nickname}</td>
                            <td className={this.state.isSelected === index ? "tableSelected" : ""}>{this.getDeviceStatus(index)}</td>
                            <td onClick={() => {
                                this.onAssetClick(index, device.parentId)
                            }} className={this.state.isSelected === index ? "tableSelected" : ""}>
                                <OverlayTrigger key="bottom" placement="right"
                                    overlay={
                                        <Tooltip
                                            id="tooltip-temperature">{this.getTimespanStr(device.deviceTemperature_Timestamp)}</Tooltip>
                                    }>
                                    <span href="#" id="TooltipTemperature"><DevTemp
                                        devTemp={device.deviceTemperature?.split(" ")?.length > 0 ? device.deviceTemperature.split(" ")[0] : device.deviceTemperature} /></span>
                                </OverlayTrigger>
                            </td>
                            <td onClick={() => {
                                this.onAssetClick(index, device.parentId)
                            }} className={this.state.isSelected === index ? "tableSelected" : ""}>
                                <OverlayTrigger key="bottom" placement="right"
                                    overlay={
                                        <Tooltip
                                            id="tooltip-battery">{device.batteryVoltage + " " + this.getTimespanStr(device.batteryVoltage_Timestamp)}</Tooltip>
                                    }>
                                    <span href="#" id="TooltipBattery"><BatterySymbol asset={this.state.assetList.find(a => a.mac === device.deviceId)} battVoltage={device.batteryVoltage} /></span>
                                </OverlayTrigger>
                            </td>
                            <td onClick={() => {
                                this.onAssetClick(index, device.parentId)
                            }} className={this.state.isSelected === index ? "tableSelected" : ""}>
                                <OverlayTrigger key="bottom" placement="right"
                                    overlay={
                                        <Tooltip
                                            id="tooltip-wifi">{device.wifiRSSI + " dBm " + this.getTimespanStr(device.wifiRSSI_Timestamp)}</Tooltip>
                                    }>
                                    <span href="#" id="TooltipWifi"><SignalSymbol sigStrength={device.wifiRSSI}
                                        sigType="Wifi" /></span>
                                </OverlayTrigger>
                            </td>
                            <td onClick={() => {
                                this.onAssetClick(index, device.parentId)
                            }} className={this.state.isSelected === index ? "tableSelected" : ""}>
                                <OverlayTrigger key="bottom" placement="left"
                                    overlay={
                                        <Tooltip
                                            id="tooltip-sensor">{device.subgRSSI + " dBm " + this.getTimespanStr(device.subgRSSI_Timestamp)}</Tooltip>
                                    }>
                                    <span href="#" id="TooltipSensorhub"><SignalSymbol sigStrength={device.subgRSSI}
                                        sigType="Subg" /></span>
                                </OverlayTrigger>
                            </td>
                            <td onClick={() => {
                                this.onAssetClick(index, device.parentId)
                            }} className={this.state.isSelected === index ? "tableSelected" : ""}>
                                <OverlayTrigger key="bottom" placement="left"
                                    overlay={
                                        <Tooltip
                                            id="tooltip-current">{this.getTimespanStr(device.current_Timestamp)}</Tooltip>
                                    }>
                                    <span href="#" id="TooltipCurrent">{device.current}</span>
                                </OverlayTrigger>
                            </td>
                            { this.state.isThreeCTDevice &&(
                                <>
                            <td onClick={() => {
                                this.onAssetClick(index, device.parentId)
                            }} className={this.state.isSelected === index ? "tableSelected" : ""}>
                                <OverlayTrigger key="bottom" placement="left"
                                                overlay={
                                                    <Tooltip
                                                        id="tooltip-current">{this.getTimespanStr(device.blowerCurrent_Timestamp)}</Tooltip>
                                                }>
                                    <span href="#" id="TooltipCurrent">{device.blowerCurrent}</span>
                                </OverlayTrigger>
                            </td>
                            <td onClick={() => {
                                this.onAssetClick(index, device.parentId)
                            }} className={this.state.isSelected === index ? "tableSelected" : ""}>
                                <OverlayTrigger key="bottom" placement="left"
                                                overlay={
                                                    <Tooltip
                                                        id="tooltip-current">{this.getTimespanStr(device.inducerCurrent_Timestamp)}</Tooltip>
                                                }>
                                    <span href="#" id="TooltipCurrent">{device.inducerCurrent}</span>
                                </OverlayTrigger>
                            </td>
                                </>)
                            }
                        </tr>
                        ) : null
                    )}
                </tbody>;
            if (this.state.paginglogListGateway?.length > 0) {
                contentforGatewayLogs = <tbody>
                    {this.state.paginglogListGateway?.map((request, index) =>
                        <tr className="alerts-table-row" key={`${request.deviceId}-tableRow-${index}`} data={index} value={index}>
                            <td className={"border-left"}>{request.id}</td>
                            <td>{request?.deviceId}</td>
                            <td>{request?.action}</td>
                            <td>{request?.hardwareRevision}</td>
                            <td>{request?.firmwareRevision}</td>
                            <td>{request?.certificateId}</td>
                            <td>{this.getDateString(request.date)}</td>
                        </tr>
                    )}
                </tbody>;
            }

            if (this.state.paginglogListSH1?.length > 0) {
                contentforSH1Logs = <tbody>
                    {this.state.paginglogListSH1?.map((request, index) =>
                        <tr className="alerts-table-row" key={`${request.deviceId}-tableRow-${index}`} data={index} value={index}>
                            <td className={"border-left"}>{request.id}</td>
                            <td>{request?.deviceId}</td>
                            <td>{request?.action}</td>
                            <td>{request?.hardwareRevision}</td>
                            <td>{request?.firmwareRevision}</td>
                            <td>{request?.certificateId}</td>
                            <td>{this.getDateString(request.date)}</td>
                        </tr>
                    )}
                </tbody>;
            }

            if (this.state.paginglogListSH2?.length > 0) {
                contentforSH2Logs = <tbody>
                    {this.state.paginglogListSH2?.map((request, index) =>
                        <tr className="alerts-table-row" key={`${request.deviceId}-tableRow-${index}`} data={index} value={index}>
                            <td className={"border-left"}>{request.id}</td>
                            <td>{request?.deviceId}</td>
                            <td>{request?.action}</td>
                            <td>{request?.hardwareRevision}</td>
                            <td>{request?.firmwareRevision}</td>
                            <td>{request?.certificateId}</td>
                            <td>{this.getDateString(request.date)}</td>
                        </tr>
                    )}
                </tbody>;
            }
        }
        let sensor3 = this.state.isFlyCatcher && this.state.currentAsset.type == "AirConditioner" && this.state.currentDevice !== undefined ?
            <div>
                <div className="txt-wide">
                    <label htmlFor="description">Sensor 3</label>
                    <textarea rows="1" cols="55"  value=  {this.state.currentDevice.sensor3}  className="custom-textarea" />
                    
                </div>
                <div className="txt-wide">
                    <label htmlFor="description">Mapped to</label>
                    <textarea rows="1" cols="55"  value= {this.cleanMapping(this.state.currentDevice.mapsTo3)}  className="custom-textarea" />


                </div>
            </div>
            : null;
        let paginationforGateway =
            <div className={"display-flex justify-content-center"}>
                <Pagination count={this.state.pageCountGateway} page={this.state.currentPageGateway} onChange={e => this.onChangePage(e, 0)} showFirstButton={this.state.pageCountGateway > 7 ? true : false} showLastButton={this.state.pageCountGateway > 7 ? true : false} size="small" />
            </div>;
        let paginationforSH1 =
            <div className={"display-flex justify-content-center"}>
                <Pagination count={this.state.pageCountSH1} page={this.state.currentPageSH1} onChange={e => this.onChangePage(e, 1)} showFirstButton={this.state.pageCountSH1 > 7 ? true : false} showLastButton={this.state.pageCountSH1 > 7 ? true : false} size="small" />
            </div>;
        let paginationforSH2 =
            <div className={"display-flex justify-content-center"}>
                <Pagination count={this.state.pageCountSH2} page={this.state.currentPageSH2} onChange={e => this.onChangePage(e, 2)} showFirstButton={this.state.pageCountSH2 > 7 ? true : false} showLastButton={this.state.pageCountSH2 > 7 ? true : false} size="small" />
            </div>;
        
        let diagnosticsContent = this.props.roles.includes(roles.admin) || this.props.roles.includes(roles.superAdmin) || this.props.roles.includes(roles.supportAdmin) || this.props.roles.includes(roles.customerSupport) ?
            <div className="white-container">
                <h5 className="sectionTitle">Diagnostic Information</h5>
                <form className={"margin-left-15"}>
                    <div className="row">
                        <div className="col">
                            <div className="txt-wide">
                                <label htmlFor="description">Cumulative Dropouts</label>
                                <label className="form-control" id="dropouts_cumulative">
                                    {this.getDiagnosticPropertyValue(this.state.assetList?.find(x => x.name === this.state.selectedDeviceId)?.properties, DIAGNOSTIC_PROPS.DROPOUT_CUMULATIVE)} dropouts
                                </label>
                            </div>
                        </div>
                        <div className="col">
                            <div className="txt-wide">
                                <label htmlFor="description">Cumulative Dropouts Seconds</label>

                                <label className="form-control" id="dropouts_cumulative_seconds">
                                    {this.getDiagnosticPropertyValue(this.state.assetList?.find(x => x.name === this.state.selectedDeviceId)?.properties, DIAGNOSTIC_PROPS.DROPOUT_SECONDS_CUMULATIVE)}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="txt-wide">
                                <label htmlFor="description">Runs (Last 24hrs)</label>
                                <label className="form-control" id="runs_24h">
                                    {this.getDiagnosticPropertyValue(this.state.assetList?.find(x => x.name === this.state.selectedDeviceId)?.properties, DIAGNOSTIC_PROPS.RUNS_LAST24H)}
                                </label>
                            </div>
                        </div>
                        <div className="col">
                            <div className="txt-wide">
                                <label htmlFor="description">Runs (Cumulative)</label>

                                <label className="form-control" id="runs_cumulative">
                                    {this.getDiagnosticPropertyValue(this.state.assetList?.find(x => x.name === this.state.selectedDeviceId)?.properties, DIAGNOSTIC_PROPS.RUNS_CUMULATIVE)}
                                </label>

                            </div>
                        </div>
                    </div>

                    <button
                        type="button"
                        className="secondary-btn btn-small lastItem margin-top-10"
                        onClick={this.openDiagnosticsTestModal}
                        disabled={this.getRepairButtonDisabled()}
                    >
                        Diagnostics Test
                    </button>

                    <button
                        type="button"
                        className="secondary-btn btn-small lastItem margin-top-10"
                        onClick={this.openDiagnosticsModal}
                        disabled={this.getRepairButtonDisabled()}
                    >
                        Advanced Diagnostics
                    </button>

                </form>
            </div>
            : null;

        const threeCTCurrents = 
            <>
                <th>Blower Current</th>
                <th>Inducer Current</th>
            </>;
            
        return (
            <div>
                <br />
                {thermostatContents && (
                    <div>
                        <h5 className="sectionTitle">Thermostat List</h5>
                        <div className="table-container-2">
                            <table className='table table-striped table-bordered table-sm table-hover'
                                aria-labelledby="tabelLabel">
                                <thead>
                                    <tr>
                                        <th>Type</th>
                                        <th>Mac</th>
                                        <th>Nickname</th>
                                    </tr>
                                </thead>
                                {thermostatContents}
                            </table>
                        </div>
                    </div>
                )}
                <h5 className="sectionTitle">Device List</h5>
                <div className="table-container-2">
                    <table className='table table-striped table-bordered table-sm table-hover'
                        aria-labelledby="tabelLabel">
                        <thead>
                            <tr>
                                <th>Type</th>
                                <th>Mac</th>
                                <th>Nickname</th>
                                <th>Status <RefreshIcon onClick={this.refreshAllStatus} /></th>
                                <th>Temp</th>
                                <th>Battery</th>
                                <th>WiFi</th>
                                <th>SensorHub</th>
                                <th>Current</th>
                                {this.state.isThreeCTDevice && threeCTCurrents}
                            </tr>
                        </thead>
                        {contents}
                    </table>
                    <ContextMenu onItemClick={this.onContextClick} ref={this.contextMenuRef} />
                </div>

                <div className="white-container">
                    <h5 className="sectionTitle">Asset Information</h5>
                    <form className={"margin-left-15"}>
                        <div className="row">
                            <div className="col">
                                <div className="txt-wide">
                                    <label htmlFor="description">Model</label>
                                    <label className="form-control" id="Model">
                                        {(this.state.currentDevice !== undefined && this.state.currentDevice?.mac !== "" )? this.getdeviceodel() : ''}
                                    </label>
                                </div>
                            </div>
                            <div className="col"> 
                                <div className="txt-wide">
                                    <label htmlFor="description">Dropouts</label>

                                    <label className="form-control" id="dropouts">
                                        {this.state.currentDevice !== undefined ? this.state.currentDevice.dropouts : ''}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div className="txt-wide">
                                    <label htmlFor="description">Firmware</label>
                                    <label className="form-control" id="firmware">
                                        {this.state.currentDevice !== undefined ? this.state.currentDevice.sensorFw : ''}
                                    </label>
                                </div>
                            </div>
                            <div className="col">
                                <div className="txt-wide">
                                    <label htmlFor="description">Last Update</label>

                                    <label className="form-control" id="last-update">
                                        {this.state.currentDevice !== undefined ? this.getDate(this.state.currentDevice.lastUpdated) : ''}
                                    </label>

                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div className="txt-wide">
                                    <label htmlFor="description">Created</label>

                                    <label className="form-control" id="created">
                                        {this.state.currentDevice !== undefined ? this.getDate(this.state.currentDevice.createdOn) : ''}
                                    </label>

                                </div>
                                <div className="txt-wide">
                                    <label htmlFor="description">Sensor 1</label>
                                    <textarea rows="1" cols="55"  value= {this.state.currentDevice !== undefined ? this.state.currentDevice.sensor1 : ''}  className="custom-textarea" />

                                </div>
                                <div className="txt-wide">
                                    <label htmlFor="description">Mapped to</label>
                                    <textarea rows="1" cols="55"  value= {this.state.currentDevice !== undefined ? this.cleanMapping(this.state.currentDevice.mapsTo1) : ''}  className="custom-textarea" />

                                </div>
                                <div className="txt-wide">
                                    <label htmlFor="description">Sensor 2</label>
                                    <textarea rows="1" cols="55"  value= {this.state.currentDevice !== undefined ? this.state.currentDevice.sensor2 : ''}  className="custom-textarea" />

                                </div>
                                <div className="txt-wide">
                                    <label htmlFor="description">Mapped to</label>
                                    <textarea rows="1" cols="55"  value={this.state.currentDevice !== undefined ? this.cleanMapping(this.state.currentDevice.mapsTo2) : ''}  className="custom-textarea" />
                                </div>
                                {sensor3}
                            </div>
                            <div className="col">
                                <div className="txt-wide">
                                    <label htmlFor="description">Current Config</label>
                                    <textarea rows="4" cols="55"  value={this.state.deviceConfiguration}  className="custom-textarea" />
                                   
                                </div>
                            </div>
                            {configLoader}
                        </div>


                        <p className="status-msg">{this.state.statusMessage}</p>
                        {(!this.state.isCustomerSupport) && (
                            <button
                                type="button"
                                className="secondary-btn btn-small lastItem"
                                onClick={this.openRepairSensorMapModal}
                                disabled={this.getRepairButtonDisabled()}
                            >
                                Repair Sensor Map
                            </button>)}

                    </form>
                </div>

                {diagnosticsContent}
                
                <br />
                {this.renderGraph()}
                {this.state.showDeviceLogs &&
                    <Tabs>
                        <TabList className={"margin-top-10 pad-left-15"} >
                            <Tab>Gateway</Tab>
                            <Tab>SH-1</Tab>
                            <Tab>SH-2</Tab>
                        </TabList>

                        <TabPanel>
                            <div className="table-container-2">
                                {/* <h5 className="sectionTitle" >Device Logs<RefreshIcon onClick={this.refreshorgetDevicelogs} /></h5> */}
                                <table className='table table-striped table-bordered table-sm table-hover'
                                    aria-labelledby="tabelLabel">
                                    <thead>
                                        <tr>
                                            <th> Id</th>
                                            <th>Device Id</th>
                                            <th>Action</th>
                                            <th>Hardware Revision</th>
                                            <th>Firmware Revision</th>
                                            <th>CertificateId</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
                                    {contentforGatewayLogs}
                                </table>
                                {paginationforGateway}
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <div className="table-container-2">
                                {/* <h5 className="sectionTitle" >Device Logs<RefreshIcon onClick={this.refreshorgetDevicelogs} /></h5> */}
                                <table className='table table-striped table-bordered table-sm table-hover'
                                    aria-labelledby="tabelLabel">
                                    <thead>
                                        <tr>
                                            <th> Id</th>
                                            <th>Device Id</th>
                                            <th>Action</th>
                                            <th>Hardware Revision</th>
                                            <th>Firmware Revision</th>
                                            <th>CertificateId</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
                                    {contentforSH1Logs}
                                </table>
                                {paginationforSH1}
                            </div>
                        </TabPanel>
                        <TabPanel>
                            <div className="table-container-2">
                                {/* <h5 className="sectionTitle" >Device Logs<RefreshIcon onClick={this.refreshorgetDevicelogs} /></h5> */}
                                <table className='table table-striped table-bordered table-sm table-hover'
                                    aria-labelledby="tabelLabel">
                                    <thead>
                                        <tr>
                                            <th> Id</th>
                                            <th>Device Id</th>
                                            <th>Action</th>
                                            <th>Hardware Revision</th>
                                            <th>Firmware Revision</th>
                                            <th>CertificateId</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
                                    {contentforSH2Logs}
                                </table>
                                {paginationforSH2}
                            </div>
                        </TabPanel>
                    </Tabs>}

                <br />
                <SensorMapModal show={this.state.showRepairSensorMap} loading={this.state.sensorsLoading}
                    sensorMap={this.state.currentDevice !== undefined ? this.state.currentDevice.sensorMap : []} sensorList={this.state.sensorList}
                    unmappedProperties={this.state.unmappedProperties} mapDict={this.state.mapDict} mapSensor={this.mapSensor}
                    updateSensorMap={this.updateSensorMap} onClick={this.showRepairSensorMapModal}
                    currentSensor={this.state.currentSensor} mappedSensors={this.state.mappedSensors} 
                                onRemoveMappedSensor={this.onRemoveMappedSensor}
                />
                <ConfirmationModal show={this.state.showTTConfirm} onYes={this.onTTConfirm}
                    onClick={this.showTTConfirmModal} message={this.state.modalMessage}
                    title={this.state.modalTitle}> </ConfirmationModal>
                <DiagnosticsModal show={this.state.showDiagnostics} loading={this.state.diagnosticsLoading} onClick={this.showDiagnosticsModal} gatewayRebootCodes={this.state.gatewayRebootCodes} properties={this.state.assetList?.find(x => x.name === this.state.selectedDeviceId)?.properties} />
                <DiagnosticsTestModal show={this.state.showDiagnosticsTest} onClick={this.showDiagnosticsTestModal} isFlycatcher={this.state.isFlyCatcher} assetType={this.state.currentAsset.type} properties={this.state.assetList?.find(x => x.name === this.state.selectedDeviceId)?.properties} />
                <ConfirmationModal show={this.state.showDeleteHomeConfirmation} onYes={this.deleteHome} onClick={this.onDeleteHomeSelect} message={this.state.modalMessage} title={this.state.modalTitle}> </ConfirmationModal>
                <HistoricalInstallCheckModal show={this.state.showHistoricalInstallChecks} onClick={this.handleViewInstallCheckReportsClicked} macId={this.state.currentHVACSystem && this.state.currentHVACSystem.children && this.state.currentHVACSystem.children[0] ? this.state.currentHVACSystem.children[0].name : null} />
            </div>);
    }

    render() {
        const { classes } = this.props;
        if (this.props.currentCustomerId === -1) {
            return (
                <div>
                    <p className="status-msg">No customer device information to display</p>
                </div>
            );
        } else {
            let loader = this.state.loading ? <Loader /> : <div />;
            let content = this.renderDevices(this.state.deviceList);
            let technicianInfo = this.state.currentHVACSystem.hasOwnProperty('children') && this.state.currentHVACSystem.children.length ?
                <div className="white-container display-flex justify-content-between">
                    <div className="margin-top-10 margin-bottom-10 display-flex align-items-center">
                        <TechnicianView macId={this.state.currentHVACSystem.children[0].name} setTechnicianInfo={this.setTechnicianInfo} />
                    </div>
                    <div className="margin-top-10 margin-bottom-10 display-flex align-items-center">
                        <button className="primary-btn btn-large width-200" onClick={() => this.handleViewInstallCheckReportsClicked()} disabled={this.state.isSystemChanged}>View Install Check Reports</button>
                    </div>
                </div> : <div></div>
            let statusLoadingContent = (this.state.statusLoading && !this.state.configLoading) ? <Loader>
                    <h3 className="status-msg text-center color-white" >{this.state.updateStatusProgress}</h3>
                </Loader>
                 : <div>{null}</div>;

            return (
                <div sx={(theme)=>({
                    [theme.breakpoints.down('md')]: {
                        marginLeft: '-225px !important',
                    },
                })}>
                    <div className='infoPage'>
                        <h3 className="pageTitle" id="tabelLabel">Devices</h3>
                        <div className={"display-none"} >{this.props.currentCustomerId}</div>
                        <AssetHierarchyView partnerId={this.props.currentPartnerId} accountId={this.props.currentCustomerId}
                          fromAssetId={(this.state.isDeleted ) ? 0: undefined}
                          onHVACSystemSelect={this.onHVACSystemSelect}
                           onNoAssetsReturned={this.onNoAssetsReturned}
                          onDeleteHomeSelect ={this.onDeleteHomeSelect}
                           
                        />
                        {technicianInfo}
                        {statusLoadingContent}
                        {content}
                        {loader}

                    </div>

                </div>
            );
        }
    }
}

class SignalSymbol extends React.Component {
    render() {
        let sigStrength = 0;
        let sig = this.props.sigStrength;
        if (this.props.sigType === "Wifi") {
            if (sig === 0) sigStrength = 0;
            else if (sig > -55) sigStrength = 4;
            else if (sig > -75) sigStrength = 3;
            else if (sig > -85) sigStrength = 2;
            else if (sig > -90) sigStrength = 1;
            else sigStrength = 0;
        }
        else {
            if (sig === 0) sigStrength = 0;
            else if (sig > -85) sigStrength = 4;
            else if (sig > -90) sigStrength = 3;
            else if (sig > -100) sigStrength = 2;
            else if (sig > -103) sigStrength = 1;
            else sigStrength = 0;
        }

        if (sigStrength === 4) {
            return (
                <Image src={require('../../img/wifi-excellent.png')} className={"wifi-icon"} />
            );
        }
        else if (sigStrength === 3) {
            return (
                <Image src={require('../../img/wifi-great.png')}  className={"wifi-icon"} />
            );
        }
        else if (sigStrength === 2) {
            return (
                <Image src={require('../../img/wifi-okay.png')} className={"wifi-icon"} />
            );
        }
        else if (sigStrength === 1) {
            return (
                <Image src={require('../../img/wifi-weak.png')} className={"wifi-icon"} />
            );
        }
        else {
            return (
                <Image src={require('../../img/wifi-unusable.png')} className={"wifi-icon"} />
            );
        }
    }
}

export default Devices;
